<template>
  <div class="page">
    <div class="page-body scroll-hidden">
      <!-- :style="{ height: footerNavVisible ? 'calc(100% - 50px)' : '100%' }" -->
      <MainMenu />
      <transition name="page-transition" mode="out-in">
        <keep-alive :include="pageKeepAlive">
          <router-view />
        </keep-alive>
      </transition>
      <div class="footer" v-if="visible">
        <p>版权所有中央团校</p>
        <p>地址:北京市海淀区西三环北路25号</p>
        <p>邮编:&nbsp;&nbsp;100089</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MainMenu from "./MainMenu.vue";
import * as dd from "dingtalk-jsapi";
export default {
  name: "BasicLayout",
  components: { MainMenu },
  data() {
    return {
      mainMenuVisible: false,
      visible: false,
    };
  },
  watch: {
    $route: {
      handler(to) {
        const meta = to.meta;
        this.mainMenuVisible = meta && meta.showMainMenu ? true : false;
        this.visible = meta && meta.showFooter == false ? false : true;
        if (to.name == this.deleteRouter) {
          this.setDeleteRouter();
        }
        this.$nextTick(() => {
          if (to && to.meta.keepAlive !== false) {
            this.setPageKeepAlivePush(to.name);
          }
        });
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      isIframe: (state) => state.app.isIframe,
      pageKeepAlive: (state) => state.app.pageKeepAlive,
      deleteRouter: (state) => state.app.deleteRouter,
    }),
  },
  created() {
    // if (dd.env.platform === "notInDingTalk") {
    //   this.$router.replace({ path: "/notInDingTalk" });
    // }
  },
  mounted() {},
  methods: {
    ...mapActions("app", ["setPageKeepAlivePush", "setDeleteRouter"]),
  },
};
</script>

<style lang="less">
.page {
  width: 100vw;
  .page-body {
    position: relative;
    width: 100vw;
    > :first-child {
      width: 100%;
    }
    .footer {
      height: 76px;
      width: 100%;
      background-color: rgb(171, 0, 0);
      color: #fff;
      text-align: center;
      padding-top: 15px;
      font-size: 12px;
    }
  }
}
</style>
